/**
 * Convierte la clave de un input (puede contener espacios, ej. "campo de ejemplo")
 * en un id válido para atributos HTML (sin espacios ni caracteres problemáticos).
 * Así se evitan fallos de estilos y asociación label/input cuando el nombre tiene espacios.
 * @param {string} key - Clave del input (id o título)
 * @returns {string} - Id seguro para usar en id= y htmlFor=
 */
export const sanitizeIdForDom = (key) => {
  if (key == null || key === '') return 'field';
  return String(key)
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9\-_.]/g, '_');
};
